
import Vue from "vue";
import Otp from "./partials/Otp.vue";

export default Vue.extend({
  components: {
    Otp
  }
});
